import { render, staticRenderFns } from "./page-layout-menu.vue?vue&type=template&id=c46107a6&scoped=true&"
import script from "./page-layout-menu.vue?vue&type=script&lang=js&"
export * from "./page-layout-menu.vue?vue&type=script&lang=js&"
import style0 from "./page-layout-menu.vue?vue&type=style&index=0&id=c46107a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46107a6",
  null
  
)

export default component.exports